/**
 * Shared localStorage persistence for list pages (filters, sort, page, search text).
 *
 * New list screens: pick a stable scope via listFilterScopes.js, then
 * readListFilters(scope) on mount and writeListFilters(scope, payload) when
 * filters change. See rolesListFilterStorage / applicantsListFilterStorage.
 */

export const LIST_FILTER_STORAGE_PREFIX = "june:listFilters:v1:";

export function listFilterStorageKey(scope) {
  return `${LIST_FILTER_STORAGE_PREFIX}${scope}`;
}

export function readListFilters(scope) {
  if (!scope || typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(listFilterStorageKey(scope));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

export function writeListFilters(scope, payload) {
  if (!scope || typeof window === "undefined" || payload == null) return;
  try {
    window.localStorage.setItem(
      listFilterStorageKey(scope),
      JSON.stringify(payload)
    );
  } catch {
    // Quota exceeded or private mode — ignore.
  }
}

export function clearListFilters(scope) {
  if (!scope || typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(listFilterStorageKey(scope));
  } catch {
    // ignore
  }
}
